import React, { useEffect, useState } from 'react'
import { getUserNotification } from '../Common/apis';
import { toast } from "react-toastify";
import Footer from '../Components/Footer';
import Navbar from '../Components/Navbar';

function Notification() {
    const [nData, setNData] = useState(null);
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);


    const getUserNoti = async () => {
        try {
            const response = await getUserNotification();
            setNData(response.data);
        } catch (error) {
            toast.error("Failed to fetch profile!");
        }
    };
    useEffect(() => {
        getUserNoti();
    }, []);

    return (
        <>
            <div className="main-div">
                <Navbar />
                {/* <div className="grid md:grid-cols-2 grid-cols-1 xl:gap-[211px] lg:gap-[40px] gap-[24px] ">
                    <div>
                        <h2 data-aos="fade-right" className="font-[500] font-sans md:text-left md:text-[80px] text-[40px] md:leading-[79px] leading-[49px] text-[#1D1837] tracking-[-0.32px] text-left">Notification</h2>
                    </div>
                    <div>
                        <p data-aos="fade-left" className="font-[400] font-sans md:text-[16px] text-[13px] md:leading-[27px] leading-[22px] text-[#4F5576] md:pb-[27px] pb-[39px]">
                            GISUL, we believe in the power of people. As a dedicated and dynamic workforce, we are committed to delivering excellence through skill, integrity, and innovation. Our team is built on strong values, a collaborative spirit, and a passion for progress.
                        </p>
                    </div>
                </div> */}
                <div className='xl:pt-[195px] lg:pt-[140px] md:pt-[100px] pt-[51px] xl:px-[100px] lg:px-[40px] px-[20px] pb-[50px]'>
                    <div className="bg-[#FFFFFF] p-[30px] rounded-[16px] border-[1px] border-[#A1A1A1] w-full">
                        <div className="profile-info-heading">
                            <h3 data-aos="fade-right">Notification</h3>
                        </div>
                        <div className="grid md:grid-cols-1 grid-cols-1 md:gap-[80px] gap-[29px] pt-[18px]">
                            <div className="flex flex-col items-start justify-center">
                                {nData?.map((item, index) => {
                                    return (
                                        <>
                                            <div key={index} className="flex justify-between items-center w-full bg-[#E4E9FD] rounded-[10px] p-[20px] mt-[20px] gap-[20px]">
                                                <div>
                                                    <h6 className="font-[600] font-poppins md:text-[20px] text-[16px] text-[#000000]">
                                                        {item.title}
                                                    </h6>
                                                    <p className="font-[400] font-sans md:text-[16px] pt-[10px] text-[14px] text-[#000000]">
                                                        {item?.message}
                                                    </p>
                                                </div>
                                                <button onClick={() => {
                                                    setSelectedNotification(item);
                                                    setIsModalOpen1(true);
                                                }}
                                                    className="px-[32px] py-[16px] font-poppins rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white">Show Notification</button>
                                            </div>
                                        </>
                                    )
                                })}
                            </div>

                        </div>
                    </div>
                </div>

                <Footer />
            </div>
            {isModalOpen1 && selectedNotification && (
                <NotificationModal
                    isOpen={isModalOpen1}
                    title={selectedNotification.title}
                    message={selectedNotification.message}
                    onClose={() => setIsModalOpen1(false)}
                />
            )}
        </>
    )
}

export default Notification



const NotificationModal = ({ isOpen, title, message, onClose }) => {
    if (!isOpen) return null;
    return (
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h6 className="font-[700] font-sans md:text-[40px] text-[26px] text-center leading-[-0.32px] text-[#6953A3]">
                    {title}
                </h6>
                <div className="flex md:pt-[27px] pt-[7px] md:pb-[37px] pb-[22px] items-center justify-center">
                    <img
                        src="/assets/slider/img6.png"
                        className="md:h-[173px] h-[150px] md:w-[173px] w-[150px]"
                        alt=""
                    />
                </div>
                <div className="flex flex-col items-center md:gap-[14px] gap-0">
                    <h6 className="font-[700] font-sans md:text-[20px] text-[16px] md:pb-[28px] pb-[25px] text-center leading-[-0.32px] text-[#6953A3]">
                        {message}
                    </h6>
                </div>
                <div className="flex flex-col gap-[16px] md:px-[26px] px-0">
                    <button className="py-[14px] text-center w-full rounded-[10px] bg-[#F1E60D] font-sans font-[400] text-[16px] text-[#263238]">
                        Subscribe Now
                    </button>
                    <button className="py-[14px] text-center w-full rounded-[10px] bg-[#6953A3] font-sans font-[400] text-[16px] text-[#FFFFFF]">
                        Not Now
                    </button>
                </div>
            </div>
        </div>
    );
};
